var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},_vm._l((_vm.steps),function(s){return _c('div',{staticClass:"number-cont"},[_c('span',{staticClass:"number",class:{active: s <= _vm.step}},[_vm._v(_vm._s(s))]),_vm._v(" "),(s < _vm.steps)?_c('span',{staticClass:"divider",class:{active: s < _vm.step}}):_vm._e()])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-735dacb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/StepIndicator.vue
// module id = GJXK
// module chunks = 0